import React, { useEffect, useState } from "react";
import Hero from "./Hero";
import Secure from "./Secure";
import Header from "./Header";
import Footer from "./Footer";
import Aos from "aos";
import "aos/dist/aos.css";
const Landing = () => {
  const [animateOut, setAnimateOut] = useState(false);
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    Aos.init({});
    const timer = setTimeout(() => {
      setAnimateOut(true);
    }, 1000); // Animation will start after 3 seconds

    return () => clearTimeout(timer);
    window.scrollTo(0, 0);
  }, []);
  const handleAnimationEnd = () => {
    setHidden(true); // Hide the element after animation ends
  };
  return (
    <>
      <div className="main-hero">
        {!hidden && (
          <>
            <img
              className={`sleft-cloud desktop ${
                animateOut ? "animate-out" : ""
              }`}
              src="/assets/images/left-cloud.png"
              alt="left-cloud"
              onAnimationEnd={handleAnimationEnd}
            />
            <img
              className={`sleft-cloud mobile ${
                animateOut ? "animate-out" : ""
              }`}
              src="/assets/images/sleft-mobile.png"
              alt="left-cloud"
              onAnimationEnd={handleAnimationEnd}
            />
          </>
        )}
        {!hidden && (
          <>
            <img
              className={`sright-cloud desktop ${
                animateOut ? "animate-out" : ""
              }`}
              src="/assets/images/right-cloud.png"
              alt="right-cloud"
              onAnimationEnd={handleAnimationEnd}
            />
            <img
              className={`sright-cloud mobile ${
                animateOut ? "animate-out" : ""
              }`}
              src="/assets/images/sright-mobile.png"
              alt="right-cloud"
              onAnimationEnd={handleAnimationEnd}
            />
          </>
        )}
        <Header />
        <Hero />
      </div>
      <div className="additional">
        <div className="container pt-5 pb-5">
          <div className="row pt-5 pb-5">
            <div className="col-lg-12">
              <h2 className="mb-3">
                What Makes Nimbus <br /> AI Unique?
              </h2>
              <p>
                Nimbus Chat leverages the Matrix protocol for secure, <br />{" "}
                open, and private communication.
              </p>
              <img
                className="ai-robot"
                src="/assets/images/Ai Robot.png"
                alt="Airbot"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="main-gradient">
        <img
          className="big-cloud"
          src="/assets/images/big-cloud.png"
          alt="big-cloud"
        />
        <img
          className="curve-cloud"
          src="/assets/images/curve-cloud.png"
          alt="big-cloud"
        />
        <img
          className="left-curve-cloud"
          src="/assets/images/left-curve.png"
          alt="big-cloud"
        />

        <Secure />
        <Footer />
      </div>
    </>
  );
};

export default Landing;
